export default `/* Ids Menu Component */
/**
 * Base Styles/Mixins for Ids Menu Component and all subcomponents.
 */
:host {
  display: block;
}

.ids-menu {
  display: block;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtbWVudSIsInNvdXJjZXMiOlsiaWRzLW1lbnUuc2NzcyIsImlkcy1tZW51LWJhc2Uuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtBQ0FBO0FBQUE7QUFBQTtBREdBO0VBQ0U7OztBQUdGO0VBQ0UiLCJzb3VyY2VzQ29udGVudCI6WyIvKiBJZHMgTWVudSBDb21wb25lbnQgKi9cbkB1c2UgJy4vaWRzLW1lbnUtYmFzZScgYXMgKjtcblxuOmhvc3Qge1xuICBkaXNwbGF5OiBibG9jaztcbn1cblxuLmlkcy1tZW51IHtcbiAgZGlzcGxheTogYmxvY2s7XG59XG4iLCIvKipcbiAqIEJhc2UgU3R5bGVzL01peGlucyBmb3IgSWRzIE1lbnUgQ29tcG9uZW50IGFuZCBhbGwgc3ViY29tcG9uZW50cy5cbiAqL1xuLy8gUmVzZXRzIHRoZSBVc2VyLUFnZW50IHN0eWxlc2hlZXQgcnVsZXMgZm9yIGA8dWw+YCBpbiBDaHJvbWVcbkBtaXhpbiByZXNldC1tZW51LXN0eWxlKCkge1xuICBkaXNwbGF5OiBibG9jaztcbiAgbWFyZ2luLWJsb2NrLWVuZDogMDtcbiAgbWFyZ2luLWJsb2NrLXN0YXJ0OiAwO1xuICBwYWRkaW5nLWlubGluZS1zdGFydDogMDtcbn1cbiJdfQ== */`;
